/**
* Animated Bars JS
* -----------------------------------------------------------------------------
*
* All the JS for the Animated Bars component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {

    className: 'animated-bars',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      // gsap.registerPlugin( ScrollTrigger );
      $( document ).ready( function() {
        function setBackgroundColors() {
          $( '.grid-item.bar' ).each( function() {
            let backgroundColor;

            // Check the window width and set the appropriate background color
            if ( $( window ).width() < 640 ) { // Small screens
              backgroundColor = $( this ).data( 'bg-small' );
            } else { // Large screens
              backgroundColor = $( this ).data( 'bg-large' );
            }

            $( this ).css( 'background-color', backgroundColor ); // Set the background color
          } );
        }

        setBackgroundColors(); // Set colors on page load

        $( window ).resize( function() {
          setBackgroundColors(); // Update colors on resize
        } );
        $( '.animated-bars' ).each( function() {
          const $cards = $( this ).find( '.grid-item' );
          const maxHeight = Math.max( ...$cards.map( ( _, card ) => $( card ).outerHeight() ).get() ); // Find the maximum width

          $cards.css( 'height', maxHeight + 'px' ); // Set all buttons to the maximum width
        } );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'animated-bars', COMPONENT );
} )( app );
